import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "table", "rowCount"]

  preview() {
    const file = this.inputTarget.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = (e) => {
      const text = e.target.result
      const rows = this.parseCSV(text)
      if (rows.length < 2) return

      const headers = rows[0]
      const dataRows = rows.slice(1)
      const previewRows = dataRows.slice(0, 5)
      const totalRows = dataRows.length

      // Build table HTML
      let html = '<thead class="bg-white/5 border-b border-white/10"><tr>'
      // Show only key columns to avoid overflow
      const keyColumns = this.findKeyColumns(headers)
      keyColumns.forEach(i => {
        html += `<th class="text-left px-3 py-2 text-xs font-semibold text-slate-400 uppercase tracking-wider whitespace-nowrap">${this.escapeHtml(headers[i])}</th>`
      })
      html += '</tr></thead><tbody class="divide-y divide-white/5">'

      previewRows.forEach(row => {
        html += '<tr>'
        keyColumns.forEach(i => {
          const val = row[i] || ''
          html += `<td class="px-3 py-2 text-xs text-slate-300 max-w-[200px] truncate">${this.escapeHtml(val)}</td>`
        })
        html += '</tr>'
      })
      html += '</tbody>'

      this.tableTarget.innerHTML = html
      this.rowCountTarget.textContent = `${totalRows} total rows found in CSV`
      this.previewTarget.classList.remove("hidden")
    }
    reader.readAsText(file)
  }

  findKeyColumns(headers) {
    // Prioritize these Shopify columns
    const preferred = ['Title', 'Handle', 'Variant SKU', 'Variant Price', 'Variant Inventory Qty', 'Option1 Value', 'Image Src']
    const indices = []
    const headerLower = headers.map(h => h.toLowerCase().trim())

    preferred.forEach(col => {
      const idx = headerLower.indexOf(col.toLowerCase())
      if (idx !== -1) indices.push(idx)
    })

    // If we didn't find preferred columns, show first 6
    if (indices.length === 0) {
      return headers.slice(0, 6).map((_, i) => i)
    }
    return indices
  }

  parseCSV(text) {
    const rows = []
    let current = []
    let field = ''
    let inQuotes = false

    for (let i = 0; i < text.length; i++) {
      const char = text[i]
      const next = text[i + 1]

      if (inQuotes) {
        if (char === '"' && next === '"') {
          field += '"'
          i++
        } else if (char === '"') {
          inQuotes = false
        } else {
          field += char
        }
      } else {
        if (char === '"') {
          inQuotes = true
        } else if (char === ',') {
          current.push(field)
          field = ''
        } else if (char === '\n' || (char === '\r' && next === '\n')) {
          current.push(field)
          field = ''
          rows.push(current)
          current = []
          if (char === '\r') i++
        } else if (char === '\r') {
          current.push(field)
          field = ''
          rows.push(current)
          current = []
        } else {
          field += char
        }
      }
    }
    // Last field
    if (field || current.length > 0) {
      current.push(field)
      rows.push(current)
    }
    return rows
  }

  escapeHtml(str) {
    const div = document.createElement('div')
    div.textContent = str
    return div.innerHTML
  }
}
